import { EventRepository } from '../repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '../domain/entities/Event';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class AppointmentStartedOverUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = async () => {
        const appointmentStartedOverPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'review',
            event_label: 'cancel and start over'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_STARTED_OVER,
            type: 'link',
            payload: appointmentStartedOverPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
